import setup from './setup';

// The first thing we want to do on the page is set up the error handler so we can record any errors that happen
setup();

export { setErrorHandler } from './onError';
